<template>
  <div class="soar-container flex flex-col gap-y-4">
    <DashboardHeader @on-date-change="fetchDashboardInfo">
      <template #headerEnd>
        <span class="tracking-wide text-brand-gray-600 text-sm">
          {{ $t('lastSyncDateTime') }}
          <span class="text-primary">
            {{ lasySync }}
          </span>
        </span>
      </template>
      <template #row1>
        <div class="flex-1 flex gap-2 justify-between md:flex-nowrap">
          <RouterLink
            :to="{ name: 'EstUserManagementLanding' }"
            class="pe-1.5 rounded-md bg-primary text-white flex items-center hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
          >
            <div class="flex justify-center items-center h-full p-2 rounded-s bg-black/10">
              <faUsers class="w-5 fill-white" />
            </div>
            <span class="pt-0.5 px-2 tracking-wide text-white text-sm pb-[1px]">
              {{ $t('estabSubUsersManagment') }}
            </span>
          </RouterLink>
          <button
            class="p-4 md:p-2 rounded-md bg-primary text-white flex items-center hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
          >
            <FontAwesomeIcon :icon="faRefresh" class="w-3 text-white" />
          </button>
        </div>
      </template>
    </DashboardHeader>
    <ExternalLinks></ExternalLinks>
    <DashboardStats :stats="dashboardData"></DashboardStats>
    <div class="pt-4 flex flex-col gap-y-1">
      <div class="flex justify-between border-b border-brand-gray-300">
        <h2 class="text-xl md:text-2xl text-primary font-medium">
          {{ $t('smartservice') }}
        </h2>
        <div class="flex gap-x-3">
          {{ value }}
          <button @click="selectedView = 'list'">
            <faGripLines
              :class="[selectedView == 'list' ? 'fill-primary' : 'fill-brand-black-secondary']"
              class="w-5"
            />
          </button>
          <button @click="selectedView = 'grid'">
            <faGrip
              :class="[selectedView == 'grid' ? 'fill-primary' : 'fill-brand-black-secondary']"
              class="w-5"
            />
          </button>
        </div>
      </div>
      <DashboardServiceDrillDown
        v-if="!isLoading"
        :selection-filter="selectionFilter"
        :regions="dashboardStore.regions"
        :modules="dashboardStore.modules"
        :services="dashboardStore.services"
        :sub-services="dashboardStore.subServices"
        @on-region-change="dashboardStore.handleRegionChange"
        @on-module-change="dashboardStore.handleModuleChange"
        @on-service-change="dashboardStore.handleServiceChange"
        @on-subservice-change="dashboardStore.handleSubserviceChange"
      ></DashboardServiceDrillDown>
      <ServiceDirectory
        v-if="!isLoading && dashboardStore.directoryItems.length > 0"
        :key="isLoading"
        :services="dashboardStore.directoryItems"
        :view-as="selectedView"
      >
        <template #gridCardCorner="{ service }">
          <div class="flex gap-x-3">
            <button
              class="w-fit pe-1 rounded-md border border-brand-gray-600 bg-white flex items-center justify-between hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
              @click="onAddFavorite(service)"
            >
              <div class="flex justify-center items-center h-full bg-black/10 p-1 rounded-s">
                <faStarOutline class="w-4 fill-white" />
              </div>
              <span
                class="ps-2 pe-1 ltr:font-sans tracking-wide text-brand-black-autofill text-xs pb-[1px]"
              >
                {{ $t('favairate') }}
              </span>
            </button>
          </div>
        </template>
        <template #gridCardActionsS="{ service }">
          <button
            class="w-fit ps-1 rounded-md bg-primary/80 hover:bg-primary flex items-center justify-between hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed font-normal"
            @click="onStartService(service)"
          >
            <span class="ps-2 pe-1 ltr:font-sans tracking-wide text-white text-xs pb-[1px]">
              {{ $t('serviceStart') }}
            </span>
            <div class="flex justify-center items-center h-full bg-black/10 p-1.5 rounded-e">
              <FontAwesomeIcon
                :icon="faArrowCircleRight"
                class="w-4 fill-primary/80 hover:fill-primary text-white"
              />
            </div>
          </button>
        </template>
        <template #gridCardActionsE="{ service }">
          <RouterLink
            :to="{ name: 'ServiceCardView', params: { serviceId: service.transactionId } }"
            target="_blank"
            class="w-fit pe-1 rounded-md bg-blue-500/80 hover:bg-blue-500 flex items-center justify-between hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed font-normal"
          >
            <div class="flex justify-center items-center h-full bg-black/10 p-1.5 rounded-s">
              <faListAlt class="w-4 fill-white" />
            </div>
            <span class="ps-2 pe-1 ltr:font-sans tracking-wide text-white text-xs pb-[1px]">
              {{ $t('serviceCard') }}
            </span>
          </RouterLink>
        </template>
        <template #rowActions="{ service }">
          <button
            class="w-fit pe-1 rounded-md border border-brand-gray-600 bg-white flex items-center justify-between hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
            @click="onAddFavorite(service)"
          >
            <div class="flex justify-center items-center h-full bg-black/10 p-1 rounded-s">
              <faStarOutline class="w-4 fill-white" />
            </div>
            <span
              class="ps-2 pe-1 ltr:font-sans tracking-wide text-brand-black-autofill text-xs pb-[1px]"
            >
              {{ $t('favairate') }}
            </span>
          </button>
          <RouterLink
            :to="{ name: 'ServiceCardView', params: { serviceId: service.transactionId } }"
            target="_blank"
            class="w-fit pe-1 rounded-md bg-blue-500/80 hover:bg-blue-500 flex items-center justify-between hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
          >
            <div class="flex justify-center items-center h-full bg-black/10 p-1.5 rounded-s">
              <faListAlt class="w-4 fill-white" />
            </div>
            <span class="ps-2 pe-1 ltr:font-sans tracking-wide text-white text-xs pb-[1px]">
              {{ $t('serviceCard') }}
            </span>
          </RouterLink>
          <button
            class="w-fit ps-1 rounded-md bg-primary/80 hover:bg-primary flex items-center justify-between hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
            @click="onStartService(service)"
          >
            <span class="ps-2 pe-1 ltr:font-sans tracking-wide text-white text-xs pb-[1px]">
              {{ $t('serviceStart') }}
            </span>
            <div class="flex justify-center items-center h-full bg-black/10 p-1.5 rounded-e">
              <FontAwesomeIcon
                :icon="faArrowCircleRight"
                class="w-4 fill-primary/80 hover:fill-primary text-white"
              />
            </div>
          </button>
        </template>
      </ServiceDirectory>
    </div>
  </div>
</template>

<script setup>
import faGrip from '@/assets/icons/faGrip.svg?component'
import faGripLines from '@/assets/icons/faGripLines.svg?component'
import faListAlt from '@/assets/icons/faListAlt.svg?component'
import faStarOutline from '@/assets/icons/faStarOutline.svg?component'
import faUsers from '@/assets/icons/faUsers.svg?component'
import client_config from '@/assets/json/client_config.json'
import client_lookups from '@/assets/json/clientLookups.json'
import DashboardHeader from '@/components/Dashboard/DashboardHeader.vue'
import DashboardServiceDrillDown from '@/components/Dashboard/DashboardServiceDrillDown.vue'
import DashboardStats from '@/components/Dashboard/DashboardStats.vue'
import ServiceDirectory from '@/components/search/ServiceDirectory.vue'
import axiosInstance from '@/services'
import { useAuthStore } from '@/stores/auth'
import { useDashboardStore } from '@/stores/dashboard'
import { useGlobalStore } from '@/stores/global'
import ExternalLinks from '@/views/establishment/dashboard/ExternalLinks.vue'
import {
  faArrowCircleRight,
  faFileLines,
  faMoneyBill,
  faRefresh
} from '@fortawesome/free-solid-svg-icons'
import { DateTime } from 'luxon'
import { notify } from 'notiwind'
import { computed, onMounted, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const router = useRouter()
const i18n = useI18n()
const authStore = useAuthStore()
const globalStore = useGlobalStore()
const dashboardStore = useDashboardStore()

const dashboardData = ref()
const isLoading = ref(true)
const selectedView = ref('list')

const selectionFilter = reactive({
  region: 1
})

onMounted(async () => {
  selectionFilter.region = authStore.user.establishmentAdminRegionId
  await dashboardStore.fetchAdminRegions()
  await dashboardStore.fetchServiceTransactions()
  isLoading.value = false
})

const lasySync = computed(() => {
  if (!dashboardData.value) return null
  return DateTime.fromJSDate(new Date(dashboardData.value.lastSyncDateTime)).toFormat('t')
})

async function fetchDashboardInfo(params) {
  isLoading.value = true
  const stats = await axiosInstance.get('/api/dashboard/typingCenter', {
    params
  })

  const {
    numberOfEstablishmentRequests,
    numberOfFinesRequests,
    numberOfInvestigationRequests,
    numberOfOtherRequests,
    numberOfReadyToPayDrafts,
    numberOfResidenceRequests,
    numberOfVisaRequests,
    totalAmount
  } = stats

  const {
    module: { visa, residency, sponsor, investigation, fines, other }
  } = client_lookups

  dashboardData.value = [
    {
      icon: faFileLines,
      count: numberOfVisaRequests,
      title: 'numberOfVisaRequests',
      routeConfig: {
        name: 'TCRequests',
        query: {
          moduleId: visa,
          ...params
        }
      }
    },
    {
      icon: faFileLines,
      count: numberOfResidenceRequests,
      title: 'numberOfResidencyRequests',
      routeConfig: {
        name: 'TCRequests',
        query: {
          moduleId: residency,
          ...params
        }
      }
    },
    {
      icon: faFileLines,
      count: numberOfEstablishmentRequests,
      title: 'numberOfEstablishmentRequests',
      routeConfig: {
        name: 'TCRequests',
        query: {
          moduleId: sponsor,
          ...params
        }
      }
    },
    {
      icon: faFileLines,
      count: numberOfFinesRequests,
      title: 'numberOfFinesRequests',
      routeConfig: {
        name: 'TCRequests',
        query: {
          moduleId: fines,
          ...params
        }
      }
    },
    {
      icon: faFileLines,
      count: numberOfInvestigationRequests,
      title: 'numberOfInvestigationRequests',
      routeConfig: {
        name: 'TCRequests',
        query: {
          moduleId: investigation,
          ...params
        }
      }
    },
    {
      icon: faFileLines,
      count: numberOfOtherRequests,
      title: 'numberOfOtherRequests',
      routeConfig: {
        name: 'TCRequests',
        query: {
          moduleId: other,
          ...params
        }
      }
    },
    {
      icon: faMoneyBill,
      count: totalAmount,
      title: 'financialTransaction',
      routeConfig: {
        name: 'TCPayments',
        query: {
          ...params
        }
      }
    },
    {
      icon: faFileLines,
      count: numberOfReadyToPayDrafts,
      title: 'numberOfReadyToPayDrafts',
      routeConfig: {
        name: 'TCRequestsForPayment',
        query: {
          ...params
        }
      }
    }
  ]

  isLoading.value = false
}

async function onStartService(service) {
  const { transactionId } = service
  const config = await globalStore.fetchConfig(transactionId)
  const { secondaryRequestUrl } = config

  const { v2ServiceFormTransactionIds } = client_config
  const {
    ServiceTransactions: { cancelLeavePermitForExemptionAndCreateNewOne },
    tahalufEstablishmentId
  } = client_lookups

  const {
    userClaimsObj: { EstablishmentId }
  } = authStore.user

  const isTahalufEst = EstablishmentId == tahalufEstablishmentId

  if (transactionId == cancelLeavePermitForExemptionAndCreateNewOne && isTahalufEst) {
    notify(
      {
        group: 'error',
        title: i18n.t('notAllowedService')
      },
      6000
    )
  }

  if (secondaryRequestUrl == v2ServiceFormTransactionIds.includes(transactionId)) {
    console.info('[onStartService] TODO: would you like to try our new form?')
    return
  }

  router.push({
    name: 'ServiceForm',
    params: { serviceId: transactionId, withException: false },
    query: {
      administrativeRegionId: dashboardStore.selectionFilter.region
    }
  })
}
</script>

<script>
export default { name: 'TypingCenterDashboard' }
</script>
<style lang="scss" scoped></style>
